// extracted by mini-css-extract-plugin
export default {"good":"SearchEventTypesPage_good__lY8I9"};